// todo: add all of the orders grid columns from default-column-configuration.js

export const OrdersGridColumns = {
  PremiumPrograms: 'premium-programs',
  WarehouseStatus: 'warehouse-status',
  PickingException: 'picking-exception',
  Tote: 'tote',
  Mode: 'mode',
  Insurance: 'insurance',
};
